import React, { CSSProperties } from "react";
import "./row.scss";

interface RowProps {
    class?: string;
    style?: CSSProperties;
    rowKey?: string;
}

export default class Row extends React.Component <RowProps> {
    render() {
        return (
            <div
                className={(this.props.class || "" ) + " row"}
                style={this.props.style}
                key={this.props.rowKey}
            >
                {this.props.children}
            </div>
        );
    }
}